import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../../context/auth';
import axios from 'axios';
import { ImpSectorLicores } from './modalImprimirLicores';
import { ImpLicenciasLicores } from './modalImpLicencias';
import TablaContribuyenteLicores from './tablaContribuyentesLicores';
import TablaTipoExpendio from './tablaTipoExpendio';
import TablaTipoTasa from './tablaTipoTasa';
import { TablaEstadoLicores } from './tablaEstadoLic';
import Grafica from './graficas';
import { ModalConfiguracionLicores } from './modalConfigLicores';

import Menu from '../../comun/Menu/Menu.jsx'
import Item from '../../comun/Menu/Item.jsx'
import ModalImprimirListadoLicencias from './ModalImprimirListadoLicencias';

function MenuPrincipalLicores() {

    const { user } = useContext(AuthContext);
    const [titulo1] = useState();
    const [titulo2] = useState();
    const [totalComercios, setTotalComercios] = useState(0.00);
    const [totalpresu, setTotalpresu] = useState(0.00);
    const [presupuesto, setPresupuesto] = useState(0.00);
    const [totalrc, setTotalrc] = useState(0.00);
    const [totalavi, setTotalavi] = useState(0.00);
    const [totalExpendios, setTotalExpendios] = useState(0.00);
    const [clasificadoresExpe, setClasificadoresExpe] = useState(0.00);
    const [clasificadoresTasa, setClasificadoresTasa] = useState(0.00);
    const [totalmenos, setTotalmenos] = useState(0.00);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [idefiscal] = useState(localStorage.getItem('idefiscal'));
    const [aniofiscal] = useState(localStorage.getItem('efiscalanio'));
    const [anioActu] = useState(localStorage.getItem('anioactu'));
    const [calculo, setCalculo] = useState({
        idmetaimpuesto: "0",
        tipoimpuestos: "",
        anio: 2022,
        enero: "0.00",
        febrero: "0.00",
        marzo: "0.00",
        abril: "0.00",
        mayo: "0.00",
        junio: "0.00",
        julio: "0.00",
        agosto: "0.00",
        septiembre: "0.00",
        octubre: "0.00",
        noviembre: "0.00",
        diciembre: "0.00",
        metapresupuestaria: "0.00",
        fechacreacion: "",
    });
    const [rm, setRM] = useState({
        enero: 0.00,
        febrero: 0.00,
        marzo: 0.00,
        abril: 0.00,
        mayo: 0.00,
        junio: 0.00,
        julio: 0.00,
        agosto: 0.00,
        septiembre: 0.00,
        octubre: 0.00,
        noviembre: 0.00,
        diciembre: 0.00
    });
    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const seleccionarRegistros = () => {
        let campos = 'idcomercio,statuslicores';
        let nomtab = 'comercio';
        let orden = 'idcomercio';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                let totalComercios = 0;
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].statuslicores === 1) {
                        totalComercios = totalComercios + 1;
                    }
                }
                setTotalComercios(totalComercios);
            }
        }).catch(function (error) {
        })
    }

    const seleccionarRegistros2 = () => {
        let campos = 'idcomercio';
        let nomtab = 'tipoexpendioxcomercio';
        let orden = 'idcomercio';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                let totalExpendios = 0;
                let comercio = []
                for (var i = 0; i < response.data.length; i++) {
                    let id = comercio.includes(response.data[i].idcomercio);
                    if (!id) {
                        comercio.push(
                            response.data[i].idcomercio
                        )
                        totalExpendios = totalExpendios + 1;
                    }
                }
                setTotalExpendios(totalExpendios);
            }
        }).catch(function (error) {
        })
    }

    const seleccionarRegistros3 = () => {
        let campos = 'idtipoexpendio';
        let nomtab = 'tipoexpendioxcomercio';
        let orden = 'idtipoexpendio';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                let clasificadoresExpe = 0;
                for (var i = 0; i < response.data.length; i++) {
                    clasificadoresExpe = clasificadoresExpe + 1;
                }
                setClasificadoresExpe(clasificadoresExpe);
            }
        }).catch(function (error) {
        })
    }

    const seleccionarRegistros4 = () => {
        let campos = 'idtipotasa';
        let nomtab = 'tipotasa';
        let orden = 'idtipotasa';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                let clasificadoresTasa = 0;
                for (var i = 0; i < response.data.length; i++) {
                    clasificadoresTasa = clasificadoresTasa + 1;
                }
                setClasificadoresTasa(clasificadoresTasa);
            }
        }).catch(function (error) {
        })
    }


    const seleccionarCalculos = () => {
        let nomtab = 'metaimpuestos';
        let anio = parseInt(anioActu);
        let tipo = 'PATENTE DE VEHICULO';
        let endpoint = `${op.conexion}/api/publicidad/consultacalculo?nomtab=${nomtab}&nanio=${anio}&tipo=${tipo}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data !== '') {
                    setCalculo(response.data);
                }
            }
        }).catch(function (error) {
        })
    }

    const seleccionarPresupuesto = () => {
        let cpuc = '301020900';
        let efis = idefiscal;
        let idtipoingre = 19;
        let tipoparti = 0;
        let nanio = aniofiscal;
        let endpoint = `${op.conexion}/api/publicidad/consultapresupuesto?cpuc=${cpuc}&efis=${efis}&idtipoingre=${idtipoingre}&tipoparti=${tipoparti}&nanio=${nanio}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status == 200) {
                let Enerov = 0.00, Febrerov = 0.00, Marzov = 0.00,
                    Abrilv = 0.00, Mayov = 0.00, Juniov = 0.00,
                    Juliov = 0.00, Agostov = 0.00, Septiembrev = 0.00,
                    Obtubrev = 0.00, Noviembrev = 0.00, Diciembrev = 0.00;
                let presut = parseFloat(response.data[0].ingre_montopresupuestado);
                let totalpr = 0.00;
                let tomes = 0.00;
                let totalmes = 0.00;
                for (var i = 0; i < response.data.length; i++) {
                    let montomes = parseFloat(response.data[i].ingre_monto);
                    totalpr = presut / 12;
                    totalmes = totalmes + montomes;
                    switch (response.data[i].ingre_nmes) {
                        case 1:
                            Enerov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 2:
                            Febrerov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 3:
                            Marzov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 4:
                            Abrilv = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 5:
                            Mayov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 6:
                            Juniov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 7:
                            Juliov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 8:
                            Agostov = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 9:
                            Septiembrev = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 10:
                            Obtubrev = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 11:
                            Noviembrev = parseFloat(response.data[i].ingre_monto);
                            break;
                        case 12:
                            Diciembrev = parseFloat(response.data[i].ingre_monto);
                            break;
                        default:
                            break;
                    }
                    setRM({
                        enero: Enerov,
                        febrero: Febrerov,
                        marzo: Marzov,
                        abril: Abrilv,
                        mayo: Mayov,
                        junio: Juniov,
                        julio: Juliov,
                        agosto: Agostov,
                        septiembre: Septiembrev,
                        octubre: Obtubrev,
                        noviembre: Noviembrev,
                        diciembre: Diciembrev
                    });
                }
                if (totalmes > presut) {
                    setTotalavi(totalmes - presut);
                } else if (presut > totalmes) {
                    setTotalmenos(presut - totalmes);
                }
                tomes = totalmes - presut;
                setTotalrc(totalmes - tomes);
                setTotalpresu(totalpr);
                setPresupuesto(presut);
            }
        }).catch(function (error) {
        })
    }

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        seleccionarRegistros();
        seleccionarRegistros2();
        seleccionarRegistros3();
        seleccionarRegistros4();
        seleccionarCalculos();
        seleccionarPresupuesto();
    }, []);

    const actualizacionItem = {
        title: 'Actualizacion',
        icon: 'fa fa-pen me-2',
        drop: [
            {
                title: 'Registro de contribuyentes',
                icon: 'fa fa-user-plus me-2',
                itemClickValue: 1
            },
            {
                title: 'Clasificador de tasas',
                icon: 'fa fa-pen-square me',
                itemClickValue: 2
            },
            {
                title: 'Clasificador de expendios',
                icon: 'fas fa-address-card me-2',
                itemClickValue: 3
            },
            {
                title: 'Estados de cuenta',
                icon: 'fas fa-address-card me-2',
                itemClickValue: 4
            }
        ]
    }
    const imprimirItem = {
        title: 'Imprimir',
        icon: 'fa fa-print me-2',
        drop: [
            {
                title: 'Listado general por setor',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 5,
            },
            {
                title: 'Listado de contribuyentes con deudas',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 6,
            },
            {
                title: 'Listado  contribuyentes situacion actual',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 7,
            },
            {
                title: 'Listado de tipos de tasas de renta de licores',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 8,
            },
            {
                title: 'Impresion licencia de licores',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 9,
            },
             {
                title: 'Listado de Solicitud de Licencia',
                icon: 'far fa-file-powerpoint me-2',
                itemClickValue: 11,
            },
        ]
    }
    const configuracionItem = {
        title: 'Configuracion',
        icon: 'fa fa-cog me-2',
        drop: [
            {
                title: 'Configuración del módulo',
                icon: 'fas fa-screwdriver me-2',
                itemClickValue: 10
            },
            {
                title: 'Usuarios',
                icon: 'fa fa-user me-2',
            },
            {
                title: 'Vincular Uso del Inmueble',
                icon: 'fa fa-user me-2'
            }
        ]
    }

    const [tabla, setTabla] = useState(0);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (tabla === 7) {
            const reporte = 'ListGenLicoresRenovacion'
            window.open(op.reportes + "/rentaslicores?" + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
            setTabla(0)
        }
        if (tabla === 8) {
            const reporte = 'Hac_LicTasas'
            window.open(op.reportes + "/rentaslicores?" + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
            setTabla(0)
        }

    }, [tabla])

    const vista = {
        0: <Grafica clasificadoresTasa={clasificadoresTasa} clasiexpe={clasificadoresExpe} totalExpendios={totalExpendios} totalp={totalComercios} datoscal={calculo} presu={presupuesto} totalpresu={totalpresu} rm={rm} totalrc={totalrc} totalavi={totalavi} totalmenos={totalmenos} />,
        1: <TablaContribuyenteLicores setTabla={setTabla} />,
        2: <TablaTipoTasa setTabla={setTabla} />,
        3: <TablaTipoExpendio setTabla={setTabla} />,
        4: <TablaEstadoLicores setTabla={setTabla} />,
        5: <ImpSectorLicores setTabla={()=>setTabla(0)} show={show} setShow={setShow} titulo1={titulo1} titulo2={titulo2} tabla={tabla} />,
        6: <ImpSectorLicores setTabla={()=>setTabla(0)} show={show} setShow={setShow} titulo1={titulo1} titulo2={titulo2} tabla={tabla} />,
        7: <Grafica clasificadoresTasa={clasificadoresTasa} clasiexpe={clasificadoresExpe} totalExpendios={totalExpendios} totalp={totalComercios} datoscal={calculo} presu={presupuesto} totalpresu={totalpresu} rm={rm} totalrc={totalrc} totalavi={totalavi} totalmenos={totalmenos} />, //<-- No abre ningun modal ni tabla
        8: <Grafica clasificadoresTasa={clasificadoresTasa} clasiexpe={clasificadoresExpe} totalExpendios={totalExpendios} totalp={totalComercios} datoscal={calculo} presu={presupuesto} totalpresu={totalpresu} rm={rm} totalrc={totalrc} totalavi={totalavi} totalmenos={totalmenos} />,  //<-- No abre ningun modal ni tabla
        9: <ImpLicenciasLicores setTabla={()=>setTabla(0)} show={show} setShow={setShow} />,
        10: <ModalConfiguracionLicores setTabla={setTabla} show={show} setShow={setShow} />,
        11: <ModalImprimirListadoLicencias setTabla={()=>setTabla(0)} show={show} setShow={setShow}/>
    }

    return user && (
        <div>
            <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)} >
                <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
                <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
                <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
                <a href="/haciendaMunicipal" className="list-group-item list-group-item-action bg-transparent text-danger fw-bold">
                    <i className="fas fa-power-off me-2" />
                    Salir
                </a>
            </Menu>
            <section className='col-12 m-0 p-0 d-flex align-items-center justify-content-center' style={{ height: '80dvh', overflowY: 'auto' }}>
                {vista[tabla]}
            </section>
        </div>
    )
} export default MenuPrincipalLicores;